import Layout from '@components/Layout'
import { NextPageContext } from 'next'
import Head from 'next/head'
import Error from '../_error'

export default function Home({ config, path, reqCookie }) {
    if (!config) {
        return (
            <>
                <Head>
                    <meta name="robots" content="noindex" />
                </Head>
                <Error statusCode={404} />
            </>
        )
    }

    const robots: string[] = []
    if (config.props?.noindex) robots.push('noindex')
    if (config.props?.nofollow) robots.push('nofollow')

    return (
        <>
            {robots.length !== 0 && (
                <Head>
                    <meta name="robots" content={robots.join(',')} />
                </Head>
            )}
            <Layout config={config} path={path} reqCookie={reqCookie} />
        </>
    )
}

Home.getInitialProps = async function ({ query, asPath, req, res }: NextPageContext) {
    if (req?.url === '/discover/profile') {
        // @ts-ignore: res redirect does not exist on the type
        res?.redirect(301, '/profile')
    }
    if (!query.pageJson && res) {
        res.statusCode = 404
    }
    // if (!query.pageJson) throw new Error(`PAGE_JSON_NOT_FOUND: ${query.title}`)
    return {
        config: query.pageJson ? JSON.parse(query.pageJson as string) : null,
        path: asPath,
        reqCookie: req?.headers.cookie,
    }
}
